import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';
import { DropDownBox } from '@apply/components';
import { LoanType } from '@apply/constants';
import { usePropertyPreferredTermType } from '../../../../queries/PropertyFields/BridgeFields';
import { PreferredTermTypeOptions } from '@apply/constants';

export interface PreferredTermProps {
    propertyGuid: string;
    width?: string;
    required?: boolean;
    isReview?: boolean;
}

export const PreferredTerm: React.FC<PreferredTermProps> = ({ propertyGuid, required = false, width, isReview = false }) => {
    const label = 'Preferred Term';
    const helperText = 'The 9 + 6 option adds 15 bps (0.15%) to origination fee.';
    const [preferredTerm, set_preferredTerm] = usePropertyPreferredTermType(propertyGuid);

    const preferredTermList = PreferredTermTypeOptions.filter((o) => o.loanTypes.includes(LoanType.Bridge)).map((o) => ({
        display: o.name,
        value: o.id,
    }));

    const findPreferredTermByValue = (value: number | undefined) => {
        return preferredTermList.find((bt) => bt.value == value)?.display;
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={findPreferredTermByValue(preferredTerm)}
                />
            ) : (
                <DropDownBox
                    id={'preferredTermDropDown'}
                    value={preferredTerm}
                    onChange={(value) => set_preferredTerm(value)}
                    required={required}
                    dataSource={preferredTermList}
                    displayExpr='display'
                    valueExpr='value'
                    width={width}
                    label={label}
                    helperText={helperText}
                />
            )}
        </>
    );
};
